import "./views.scss";

import { useEffect } from "react";

import NeedMoreHelp from "../components/buttons/NeedMoreHelp";
import PrimaryButton from "../components/buttons/PrimaryButton";
import { useFormFlowContext } from "../components/forms/FormFlowContext";
import { delay } from "../helpers/helpers";
import useSendAuthLinkError from "../helpers/hooks/useSendAuthLinkError";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";
import { sendAuthLink } from "../services/requests";
import appSettings from "../settings/appSettings";

const SignIn = () => {
  const { pageForward, setView, setFormSuccess, userData } = useFormFlowContext();
  const { supporterData } = appSettings;
  let userEmail = userData?.email || supporterData?.email;
  // fallback to supporterData.email if userData.email is undefined due to redirect directly to sign in page

  const { onSendAuthLinkError } = useSendAuthLinkError();

  if (!userEmail) {
    const err = "Email data missing, required by the Sign In page to send one time login email.";
    throw new Error(err, { cause: "missing_email", userData, supporterData });
  }

  useEffect(() => {
    triggerCommunityRegistrationView({
      event_action: "signin_to_bettermode",
      event_label: "signin_to_bettermode"
    });
  }, []);

    const sendAnalyticsOnetimeLogin = (label = "send_one-time_login_email") => {
      triggerCommunityRegistrationView({
        "event_action": "send_one-time_login_email",
        "event_label": label,
      });
    }

  const sendEmail = async () => {
    pageForward();
    setFormSuccess(false);
    sendAnalyticsOnetimeLogin("send_one-time_login_email");
    await sendAuthLink(userEmail)
      .then(() => delay(1500))
      .then(async () => {
        setFormSuccess(true);
        setView("one_time_login");
      })
      .catch(onSendAuthLinkError("Error sending one-time login email", "signin"));
  };

  return (
    <div className="views display-grid gap-base">
      <div className="header">
        <h1 className="serif">
          <strong>Sign In</strong>
        </h1>
      </div>
      <p className="base">
        {`It looks like you already have a World Vision account! \
          Click the button below to send a one-time login email to ${userEmail}.`}
      </p>
      <footer>
        <PrimaryButton classes="wide" handleClick={() => sendEmail()}>
          Send One-Time Login Email
        </PrimaryButton>
        <NeedMoreHelp from="signin" />
      </footer>
    </div>
  );
};

export default SignIn;
